import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { getPrevPageHref } from 'store/common/selectors';

export const useHistoryBack = () => {
  const history = useHistory();
  const prevPageHref = useSelector(getPrevPageHref);

  return () => {
    if (
      Boolean(prevPageHref) ||
      (document.referrer && document.referrer.includes(window.location.host))
    ) {
      history.goBack();

      return;
    }

    history.replace('/finder');
  };
};
